import { MenuItem, Select } from "@mui/material";
import { Customer } from "../../../services/api/__generated__/backend_gateway-types";

export const CustomerSelectorComponent = (props: {
  onSelect: (customerId: string | null) => void;
  allCustomers: Customer[];
  selectedCustomerId: string | null;
}) => {
  const { onSelect, allCustomers, selectedCustomerId } = props;

  // Ensure value matches a MenuItem (avoids MUI "out-of-range value" when
  // selectedCustomerId is set before allCustomers has loaded)
  const validValue =
    selectedCustomerId && allCustomers.some((c) => c.id === selectedCustomerId)
      ? selectedCustomerId
      : "NO CUSTOMER SELECTED";

  return (
    <Select
      size="small"
      value={validValue}
      sx={{
        height: 34,
        fontSize: 14,
        fontWeight: 600,
        color: (t) => t.palette.atomic.brandBlueDark,
        "& .MuiSelect-select": {
          fontSize: 14,
          display: "flex",
          alignItems: "center",
          paddingTop: 0,
          paddingBottom: 0,
        },
      }}
      MenuProps={{ sx: { "& .MuiMenuItem-root": { fontSize: 14 } } }}
      renderValue={(value) => {
        if (!value || value === "NO CUSTOMER SELECTED") {
          return selectedCustomerId || "Select customer";
        }
        const customer = allCustomers.find((c) => c.id === value);
        return customer?.name || customer?.id || value;
      }}
    >
      <MenuItem
        value="NO CUSTOMER SELECTED"
        key="NO CUSTOMER SELECTED"
        onClick={() => onSelect(null)}
      >
        Clear selection
      </MenuItem>
      {allCustomers
        ?.slice()
        .sort((a, b) => {
          const nameA = a.name || a.id || "";
          const nameB = b.name || b.id || "";
          return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
        })
        ?.map((customer: Customer) => (
          <MenuItem
            value={customer.id}
            key={customer.id}
            onClick={() => {
              if (customer.id) {
                onSelect(customer.id);
              }
            }}
          >
            {customer.name || customer.id}
          </MenuItem>
        ))}
    </Select>
  );
};
